// extracted by mini-css-extract-plugin
export default {"component":"HistoryMessage_component__rX4hT","message":"HistoryMessage_message__ASk6U"};